import { useNavigate } from 'react-router-dom';
import './AboutIntro.scss';

const introContent = {
  title: 'Porquê a Plover?',
  subtitle:
    'Criamos soluções digitais pensadas para PMEs. Sem complicações, com proximidade e com resultados práticos.',
  logoUrl: '/images/aboutpage/logo-icon.webp',
};

const ctaBlock = {
  title: 'Quer transformar o seu negócio?',
  description:
    'Estamos prontos para ajudar. Fale connosco e dê o primeiro passo para uma jornada digital mais eficaz.',
  buttonText: 'Fale Connosco',
};

const AboutIntro = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/', { state: { scrollToContact: true } });
  };

  return (
    <section className="about-intro section">
      <div className="wrapper wrapper--large">
        <div className="row">
          <div className="col">
            <h1 className="wrapper__title">{introContent.title}</h1>
            <p className="h5">{introContent.subtitle}</p>
            <img
              alt=""
              className="about-intro-logo"
              src={introContent.logoUrl}
            />
          </div>
          <div className="col col__highlight">
            <h2 className="wrapper__title wrapper__title--centered">
              {ctaBlock.title}
            </h2>
            <p>{ctaBlock.description}</p>
            <button onClick={handleClick} className="cta-filled">
              {ctaBlock.buttonText}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutIntro;